import { defineComponent as _defineComponent } from 'vue'
import { ref, Ref, computed, watch } from 'vue';
import store from '@/store';
import { useI18n } from 'vue-i18n';

import { MultiSelectOption, UserLabelGetters, UserLabelActions, UserLabelFilter } from '@/types';
import { FilterIcon } from '@heroicons/vue/solid';


export default /*@__PURE__*/_defineComponent({
  __name: 'UserLabelListFilters',
  setup(__props, { expose: __expose }) {
  __expose();

const { t } = useI18n();

const filtersOpened = ref(false);

const defaultFilter = computed(() => store.getters[UserLabelGetters.DEFAULT_FILTER]);

const filter: Ref<UserLabelFilter> = ref({
    isActive: defaultFilter.value.isActive,
});

const storeFilters = computed<UserLabelFilter>(() => store.getters[UserLabelGetters.FILTER]);

const isActiveFilterOptions = [
    {
        label: t('userLabel.filters.isActive.options.active'),
        value: true,
    },
    {
        label: t('userLabel.filters.isActive.options.inactive'),
        value: false,
    },
] as MultiSelectOption[];

function applyFilters() {
    store.dispatch(UserLabelActions.SET_FILTER, filter.value);
}

function clearFilters() {
    store.dispatch(UserLabelActions.CLEAR_FILTER);
    refreshLocalFilter();
}

function refreshLocalFilter() {
    filter.value.isActive = storeFilters.value.isActive;
}

watch(filtersOpened, () => {
    refreshLocalFilter();
});

const __returned__ = { t, filtersOpened, defaultFilter, filter, storeFilters, isActiveFilterOptions, applyFilters, clearFilters, refreshLocalFilter, get FilterIcon() { return FilterIcon } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})